export default "__VITE_PUBLIC_ASSET__6e229bb1__"